import React, { useState, useEffect } from 'react';
import './Toast.css';

const Toast = ({ show, message, type = 'success', duration = 3000, onClose }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (show) {
            setVisible(true);

            const timer = setTimeout(() => {
                setVisible(false);
                if (onClose) onClose();
            }, duration);

            return () => clearTimeout(timer);
        }
    }, [show, duration, onClose]);

    if (!show && !visible) return null;

    const getToastClass = () => {
        switch (type) {
            case 'success':
                return 'toast-success';
            case 'error':
                return 'toast-error';
            case 'warning':
                return 'toast-warning';
            case 'info':
                return 'toast-info';
            default:
                return 'toast-success';
        }
    };

    return (
        <div className={`toast ${getToastClass()} ${visible ? 'show' : 'hide'}`}>
            <div className="toast-content">
                {type === 'success' && (
                    <div className="toast-icon">
                        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                    </div>
                )}
                <div className="toast-message">{message}</div>
            </div>
        </div>
    );
};

export default Toast;
